import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "../src/assets/css/reset.css";
import "../src/assets/css/style.css";
import Header from "../src/components/header.vue";
import Footer from "../src/components/footer.vue";
import headerSearch from "./components/headerSearch.vue";
import Fixed from "./components/Fixed.vue";
import mainTab from "./components/mainTab.vue";
import * as api from "./request/api.js"; // 导入api接口
import "@/utils/rem.js";
import * as helper from "@/utils/helper.js";
import { createHead } from "@unhead/vue";
import ElementPlus from "element-plus";
import 'element-plus/dist/index.css'; // 引入 Element Plus 样式
import VueCookies from 'vue-cookies';
import eventBus from "@/utils/eventBus.js"; // 引入封装的方法
import loginPop from "./components/loginPop.vue";
const app = createApp(App);
const head = createHead();
app.use(head);
app.config.productionTip = false; // 关闭生产提示
app.component("Header", Header);
app.component("Footer", Footer);
app.component("headerSearch", headerSearch);
app.component("Fixed", Fixed);
app.component("mainTab", mainTab);
app.component("loginPop", loginPop);
app.config.globalProperties.$api = api;
app.config.globalProperties.$h = helper;
app.config.globalProperties.$bus = eventBus;
app.use(store).use(router);
app.use(ElementPlus);
import popup from "../src/components/popup.vue";
app.component("popup", popup);
import pagination from "../src/components/pagination.vue";
app.component("pagination", pagination);

// 使用 vue-cookies 插件
app.use(VueCookies);
// 设置 cookie 的默认配置（可选）
app.config.globalProperties.$cookies.config('7d'); // 例如，设置 cookie 过期时间为 7 天

app.mount('#app');
